import { render, staticRenderFns } from "./BatchDetailsToBill.vue?vue&type=template&id=38106e57&scoped=true&lang=pug&"
import script from "./BatchDetailsToBill.vue?vue&type=script&lang=js&"
export * from "./BatchDetailsToBill.vue?vue&type=script&lang=js&"
import style0 from "./BatchDetailsToBill.vue?vue&type=style&index=0&id=38106e57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38106e57",
  null
  
)

component.options.__file = "BatchDetailsToBill.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
  VSpacer,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
})
